import React, { FC } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { IonModal } from '@ionic/react'
import { getPlatform } from '@utils'
import './index.scss'

import cursorImg from '@img/mkt/cursor.png'
import arrowImg from '@img/mkt/arrow.png'

const { isWeixinMiniProgram } = getPlatform()

interface IProps {
  reject?: () => void;
}

const GuideModal: FC<IProps> = (props: IProps) => {
  const { reject } = props
  return (
    <IonModal
      cssClass='guide-modal'
      isOpen
      animated={false}
    >
      <div className={`guide-content ${isWeixinMiniProgram ? 'weixin-mini' : ''}`} data-cypid='guideModalClose' onClick={reject}>
        <div className='tip-box '>
          <div className='cursor' style={{ backgroundImage: `Url(${cursorImg})` }}></div>
          <div className='text'>{i18n.t('mkt.activity.sharePartner')}</div>
        </div>
        <div className='arrow' style={{ backgroundImage: `Url(${arrowImg})` }}></div>
      </div>
    </IonModal>
  )
}

export default observer(GuideModal)
